import React, { FC } from 'react'
import { useModalControls, useSelectedBooking, useSelectedIndex } from '../hooks'
import { useBookingsCount } from '../../bookings/hooks'
import { BASE_URL } from '../../constants'
import { formatDate } from '../../util'



const MugshotModal: FC = () => {
  const booking = useSelectedBooking()
  const index = useSelectedIndex()
  const bookingsCount = useBookingsCount()

  const { next, previous, close } = useModalControls()

  const squelchEvent = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
  }

  if (booking === null) return null

  const bookingDate = booking.bookingDate ? formatDate(new Date(booking.bookingDate)) : "Unknown"
  const releaseDate = booking.releaseDate
    ? `Released ${formatDate(new Date(booking.releaseDate))}`
    : (booking.homeDetention ? "Out to Home Detention" : "Still Incarcerated")

  return (
    <div id="overlayContainer" className={booking === null ? "hide" : ""} onClick={close}>
      <div id="overlay" onClick={squelchEvent}>
        <span id="closeOverlay" onClick={close}><i className="icon-remove"></i></span>
        <img id="featuredImage" src={`${BASE_URL}mugshots/${booking.id}`} alt="" />
        <table className="table">
          <tbody>
            <tr>
              <th>Name</th>
              <td id="featuredName">{booking.name}</td>
            </tr>
            <tr>
              <th>Booked</th>
              <td id="featuredBooked">{bookingDate}</td>
            </tr>
            <tr>
              <th>Status</th>
              <td id="featuredStatus">{releaseDate}</td>
            </tr>
          </tbody>
        </table>
        <div className="row-fluid" id="featuredPager">
          <div className="span3">
            <span className={"btn" + (index === 0 ? " disabled" : "")} onClick={previous}><i className="icon-chevron-left"></i></span>
          </div>
          <div className="span6">
            <p className="text-center">{(index || 0) + 1} of {bookingsCount}</p>
          </div>
          <div className="span3">
            <span className={"btn pull-right" + (index === bookingsCount - 1 ? " disabled" : "")} onClick={next}><i className="icon-chevron-right"></i></span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MugshotModal